import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue, query, orderByChild, equalTo, update, remove, set, push, off, get } from "firebase/database";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyAHMXJoHmGXzHzyf1vypUrrh13wkByonG4",
    authDomain: "shemies-math.firebaseapp.com",
    projectId: "shemies-math",
    storageBucket: "shemies-math.firebasestorage.app",
    messagingSenderId: "866156669476",
    appId: "1:866156669476:web:72e7f849ac0fa178c086b1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getDatabase(app);
const auth = getAuth(app);

export { db, auth, ref, onValue, query, orderByChild, equalTo, update, remove, set, push, off, get };
